import { Action } from "../types"
import { SidebarAction } from "./actions"
import { SidebarState } from "./types"

const initial_sidebar: SidebarState = {
  isOpen: false,
  header: undefined,
  content: undefined,
  width: 440,
  info_sidebar: {
    isOpen: false,
    header: undefined,
    content: undefined,
    width: 440,
  }
}

const sidebarReducer = (state = initial_sidebar, action: Action): SidebarState => {
  const { data, type } = action ?? {}
  switch (type) {
    case SidebarAction.SET_SIDEBAR:
      return {
        ...state,
        ...data
      }
      break

    case SidebarAction.SET_IS_OPEN:
      return {
        ...state,
        isOpen: data,
      }
      break

    case SidebarAction.SET_INFOBAR:
      return {
        ...state,
        info_sidebar: {
          ...state.info_sidebar,
          ...data
        }
      }
      break

    case SidebarAction.SET_INFOBAR_IS_OPEN:
      return {
        ...state,
        info_sidebar: {
          ...state.info_sidebar,
          isOpen: data
        }
      }
      break
      
    default:
      return state
  }
}

export { sidebarReducer, initial_sidebar }
